import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["panel", "expandIcon", "collapseIcon"];
  static values = {
    storageKey: String,
  };

  declare readonly panelTargets: HTMLElement[];
  declare readonly expandIconTargets: HTMLElement[];
  declare readonly collapseIconTargets: HTMLElement[];
  declare readonly storageKeyValue: string;

  connect(): void {
    if (this.#isCollapsed()) {
      this.#applyCollapsed();
    }
  }

  toggle(): void {
    if (this.#isCollapsed()) {
      localStorage.removeItem(this.storageKeyValue);
      this.#applyExpanded();
    } else {
      localStorage.setItem(this.storageKeyValue, "1");
      this.#applyCollapsed();
    }
  }

  #isCollapsed(): boolean {
    return localStorage.getItem(this.storageKeyValue) === "1";
  }

  #applyCollapsed(): void {
    this.panelTargets.forEach((panel) => panel.classList.add("hidden"));
    this.expandIconTargets.forEach((icon) => icon.classList.remove("hidden"));
    this.collapseIconTargets.forEach((icon) => icon.classList.add("hidden"));
  }

  #applyExpanded(): void {
    this.panelTargets.forEach((panel) => panel.classList.remove("hidden"));
    this.expandIconTargets.forEach((icon) => icon.classList.add("hidden"));
    this.collapseIconTargets.forEach((icon) => icon.classList.remove("hidden"));
  }
}
